import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/hIPs3lI8uzALriLJ51LF/locations/Mw6adIcIVLRhyovm9wBX`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="310px" alt="About" />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={`https://order.codefusion.tech/restaurants/hIPs3lI8uzALriLJ51LF/locations/Mw6adIcIVLRhyovm9wBX`}
            >
              <CFView hover>
                <CFImage
                  src={orderPickupButton}
                  maxWidth="360px"
                  w="24vw"
                  alt="About"
                />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
